var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app"},[_c('PcHeader',{staticClass:"d-none d-sm-block"}),_c('SpHeader',{staticClass:"d-block d-sm-none"}),_c('v-main',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }